import React from 'react';
import PropTypes from 'prop-types';
import Banner from './Banner';

export const NIVA_HEADER = 'Time is running out.';

const NIVABanner = (props) => {
    const trackingData = {
        type: 'TRACK_NIVA_BANNER_CLICK',
        meta: {
            analytics: {
                action: 'NivaBannerClick',
                category: props.category,
            },
        },
    };

    const destinationURL =
        props.category == 'search'
            ? 'https://www.nivassoc.org/take-action?utm_source=eventbrite&utm_medium=banner&utm_campaign=search'
            : 'https://www.nivassoc.org/take-action?utm_source=eventbrite&utm_medium=banner&utm_campaign=home';

    return (
        <Banner leftAccentColor="#F05537" style="dark" header={NIVA_HEADER}>
            <span>
                Join the movement to keep independent venues alive.
                <a
                    onClick={() => {
                        props.handleTracking(trackingData);
                    }}
                    rel="noopener noreferrer"
                    target="_blank"
                    href={destinationURL}
                >
                    Send a message to Congress
                </a>{' '}
                to #SaveOurStages.
            </span>
        </Banner>
    );
};

NIVABanner.propTypes = {
    handleTracking: PropTypes.func,
    trackingParams: PropTypes.string,
    category: PropTypes.string,
};

export default NIVABanner;
